window.gred = window.gred || {};
(function(a){var b=a({});a.subscribe=function(){b.on.apply(b,arguments)},a.unsubscribe=function(){b.off.apply(b,arguments)},a.publish=function(){b.trigger.apply(b,arguments)}})(jQuery);

gred.init = function () {
  gred.initAddToCart();
  gred.dropdown();
  gred.hideDropdown();
  gred.quantity();
  gred.updatePricing();
  gred.popup();
  gred.uPopup();
  gred.tabs();
  gred.hideFpu();
  gred.hidePopup();
  gred.checkItemsInMiniCart();
  gred.removeItemsInMiniCart();
  gred.btnAddtocart();
  gred.swiperslider();
  gred.upsellPricesOverride();
  gred.overrideGrowaveWishlistStyles();
  //gred.acceptCookiePopup();
};


jQuery(document).ready(function(){
  $('.tabs-menu_btn').click(function(e){
    e.preventDefault();
    $(this).parent().find('.tabs-title').toggleClass('tabs-open');
  });

  "use strict";
  //FOOTER MOBILE
  gred.hideFpu();
  //TOGGLE MENU

  $('.toggle-menu .caret').on('click', function(e) {
    e.preventDefault();
    $(this).parent().next().slideToggle("fast");
    return false;
  });

  //CURRENCY
  $('.currency-Picker .grt-dropdown--content a').on('click', function(e) {
    $("select.currency-picker").val($(this).data('value')).change();
    $(this).closest('.grt-dropdown--content').removeClass('active');
    e.preventDefault();
  });

  //COLLECTION SORTBY
  $('.collection-sortBy .grt-dropdown--content a').on('click', function(e) {
    var label = $(this).html();
    $('.collection-sortBy .dropdown-label').html(label);
    $(this).closest('.grt-dropdown--content').removeClass('active');
  });

  //OFFCANVAS MENU
  $('.mob-screen').click(function(e){
    e.preventDefault();
    $(this).toggleClass("active");
    $('.mob-content').removeClass("active");
    $('html').css({'overflow-y': 'auto'});
    $('body').css({'overflow-y': 'unset', 'width': 'inherit'});
    $(window).scrollTop(window.scrollTop || 0);
    window.scrollTop = undefined;
  });

  $('.mob-close').click(function(e){
    e.preventDefault();
    $('.mob-screen').removeClass("active");
    $('.mob-content').removeClass("active");
    $('body').removeClass('mob-nav-active');
    $('html').css({'overflow-y': 'auto'});
    $('body').css({'overflow-y': 'unset', 'width': 'inherit'});
    $(window).scrollTop(window.scrollTop || 0);
    window.scrollTop = undefined;
  });
   //OFFCANVAS MENU VERTICAL
  $('.mob-menus').click(function(e){
    e.preventDefault();
    $('.mob-contents').toggleClass("active");
    $('.mob-screens').addClass("active");
  });

  $('.mob-screens').click(function(e){
    e.preventDefault();
    $(this).toggleClass("active");
    $('.mob-contents').removeClass("active");
  });

  $('.mob-closes').click(function(e){
    e.preventDefault();
    $('.mob-screens').removeClass("active");
    $('.mob-contents').removeClass("active");
  });

  //COLOR SWATCH
  $('.variant-option__list li label').click(function(e){
    var link = $(this).data('image');
    var $product = $(this).parents('.product-grid-item');
    //$product.addClass('loading-image');

    $(this).closest('.product-grid-item').find('.product-item-photo img.as').attr("src",link).one('load', function() {
    //$product.removeClass('loading-image');
    });
    $('.variant-option__list li label').removeClass('active');
    $(this).addClass('active');
  });


  /* CUSTOMER PAGE */

  //SIDEBAR ON MOBILE
  $(".open-sidebar").click(function(e){
    e.preventDefault();
    $("body").toggleClass("open-sboff");
    $(".sidebar-overlay").toggleClass("show");
    $(".sidebar-offcanvas").toggleClass("active");
    $('html').css({'overflow-y': 'hidden'});
  });
  $(".sidebar-overlay").click(function(e){
    e.preventDefault();
    $("body").toggleClass("open-sboff");
    $(".sidebar-overlay").toggleClass("show");
    $(".sidebar-offcanvas").toggleClass("active");
    $('html').css({'overflow-y': 'auto'});
  });



  $(".more-views .mv-item").click(function(e){
    var attr = $(this).attr('data-val');
    var smallImage = $(this).attr('data-image');
    var largeImage = $(this).attr('data-zoom-image');

    $(".cloud-zoom").attr("href", largeImage)
    $("#single-photos").attr("src", smallImage)

    $(".mousetrap").remove();
    $(".cloud-zoom").CloudZoom();

    e.preventDefault();
  });

  //HEADER STICKY
  var hH = $('.header--fixed').outerHeight(true);
  $('.header-vsb').css( "height", hH );

});

/*============================================================================
#ADDITIONS
==============================================================================*/
//QUANTITY
gred.quantity = function () {
  var maxQuantity = window.config.max_product_quantity || 999;
  $('.qtyplus').on('click', function(e){
    e.preventDefault();
    fieldName = $(this).attr('data-field');
    var currentVal = parseInt($('input[data-field='+fieldName+']').val());
    if (!isNaN(currentVal) && currentVal < maxQuantity) {
      $('input[data-field='+fieldName+']').val(currentVal + 1);
      gred.updatePricing();
    }
    return false;
  });

  $(".qtyminus").on('click', function(e) {
    e.preventDefault();
    fieldName = $(this).attr('data-field');
    var currentVal = parseInt($('input[data-field='+fieldName+']').val());
    if (!isNaN(currentVal) && currentVal > 1) {
      $('input[data-field='+fieldName+']').val(currentVal - 1);
      gred.updatePricing();
    }
    return false;
  });
}

//DROPDOWN
gred.dropdown = function () {
  $('.grt-dropdown > a').click(function() {
    if($(this).closest('.grt-dropdown').find('.grt-dropdown--content').hasClass('active')){
      $('.grt-dropdown--content').removeClass('active');
      $(this).removeClass('active');
    }else{
      $('.grt-dropdown > a').removeClass('active');
      $('.grt-dropdown--content').removeClass('active');
      $(this).closest('.grt-dropdown').find('.grt-dropdown--content').addClass('active');
      $(this).addClass('active');
    }
    return false;
  });
};

gred.hideDropdown = function () {
  $(document).on('click touch', function(e) {
    var dropdown = $(".grt-dropdown--content");
    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
      dropdown.removeClass('active');
      $('.grt-dropdown > a').removeClass('active');
    }
  });
};

//TABS
gred.tabs = function () {
  $(".e-tabs").each( function(){
    $(this).find('.tabs-title li:first-child').addClass('current');
    $(this).find('.tab-content').first().addClass('current');

    $(this).find('.tabs-title li').click(function(e){
      var tab_id = $(this).attr('data-tab');
      var url = $(this).attr('data-url');
      $(this).closest('.e-tabs').find('.tab-viewall').attr('href',url);

      $(this).closest('.e-tabs').find('.tabs-title li').removeClass('current');
      $(this).closest('.e-tabs').find('.tab-content').removeClass('current');

      $(this).addClass('current');
      $(this).closest('.e-tabs').find("#"+tab_id).addClass('current');
      e.preventDefault();
    });
  });


};

//Popup
gred.popup = function () {
  $('.link-popup').click(function(e) {
    var data = '.'+$(this).attr('data-content');
    $('.gred-popup').toggleClass('active');
    setTimeout(function () {
      $(data).addClass('active');
    }, 200);

    return false;
  });
};

gred.uPopup = function () {
  $(document).on('click touch', function(e) {
    var dropdown = $(".p-size-guide.active");
    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
      $('.gred-popup .item').removeClass('active');
      setTimeout(function () {
        $('.gred-popup').removeClass('active');
      }, 200);
    }
  });

  $('.close-popup').click(function(e) {
    $('.gred-popup .item').removeClass('active');
    setTimeout(function () {
      $('.gred-popup').removeClass('active');
    }, 200);
    return false;
  });

};

/********************************************************
# SWIPER CAROUSEL
********************************************************/
gred.swiperslider = function (selector) {
  var swipers = [];

  function initSwiper($el){
    var autoplay = $el.data('autoplay');
    var paginationCss = $el.data('pagination');
    var direction = $el.data('direction');
    var isAuto = $el.data('items') === 'auto';
    var config = {
      spaceBetween: $el.data('margin'),
      slidesPerView: isAuto ? 'auto' : parseFloat($el.data('items') || 1),
      direction: direction || 'horizontal',
      slidesPerColumn: parseFloat($el.data('row') || 1),
      paginationClickable: true,
      lazy: true,
      loop: true,
      pagination: paginationCss ? {
        el: paginationCss,
        clickable: true,
        dynamicBullets: false,
        renderBullet: function (index, className) {
          return '<span class="' + className + '" tabindex="' + index + '" role="button" aria-label="Go to slide ' + index + '"></span>';
        },
      } : false,
      slidesPerGroup: 1,// parseFloat($el.data('slides-per-group') || 1),
      navigation: {
        nextEl: $el.parent().find('.swiper-button-next'),
        prevEl: $el.parent().find('.swiper-button-prev'),
      },
      scrollbar: {
        el: $el.find('.swiper-scrollbar'),
      },
      breakpoints: {
        300: {
          slidesPerView: isAuto ? 'auto' : parseFloat($el.data('xs') || 1),
          slidesPerGroup: isAuto ? 1 : parseFloat($el.data('slides-per-group-xs') || 1),
        },
        480: {
          slidesPerView: isAuto ? 'auto' : parseFloat($el.data('xs') || 1),
          slidesPerGroup: isAuto ? 1 : parseFloat($el.data('slides-per-group-xs') || 1),
        },
        768: {
          slidesPerView: isAuto ? 'auto' : parseFloat($el.data('sm') || 2),
          slidesPerGroup: isAuto ? 1 : parseFloat($el.data('slides-per-group-sm') || 1),
        },
        991: {
          slidesPerView:  isAuto ? 'auto' : parseFloat($el.data('md') || 3),
          slidesPerGroup:  isAuto ? 1 : parseFloat($el.data('slides-per-group-md') || 1),
        },
        1199: {
          slidesPerView:  isAuto ? 'auto' : parseFloat($el.data('lg') || 3),
          slidesPerGroup:  isAuto ? 1 : parseFloat($el.data('slides-per-group-lg') || 1),
        }
      },
      autoplay: autoplay ? {
        delay: parseInt(autoplay),
        disableOnInteraction: false,
      }: false,
      effect: $el.data('effect') || 'slide',
      centeredSlides: !!isAuto,
      on: {
        init: function() {
          var el = $el.get(0);
          el.style.height = 'auto';
          el.style.opacity = '1';
          el.style.visibility = 'visible';
          if (autoplay) {
            el.addEventListener('mouseenter', () => {
              this.autoplay.stop();
            });
            el.addEventListener('mouseleave', () => {
              this.autoplay.start();
            });
          }
        },
      },
    };
    var swiper = new Swiper($el, config);
    // Handle Safari address bar issue
    // Ref: https://github.com/nolimits4web/swiper/issues/5091
    if (direction === 'vertical' && swiper.device.ios) {
      window.removeEventListener('resize', swiper.resize.resizeHandler)
    }
    return swiper;
  }


  $(".swiper-container").each(function() {
    var swiper = initSwiper($(this));
    swipers.push(swiper);
  });

  function rerenderSwipers() {
    for(var i=0; i>swipers.length; i++) {
      swipers[i].autoplay.stop();
      swipers[i].destroy(false, true);
      swipers[i].autoplay.start();
    }
  }

  var timer = null;
  $(window).on('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(rerenderSwipers, 1000);
  });
};

/********************************************************
# SHOW POPUP
********************************************************/
gred.showPopup = function (selector) {
  $(selector).parents('.theme-popup').find('.fpu-bg').addClass('active');
  window.scrollTop = $(document).scrollTop();
  setTimeout(function () {
    $(selector).addClass('active');
    $(selector + ' .fpu-inner').addClass('active');
  }, 200);
  if ($('html').get(0).scrollHeight > $('html').get(0).clientHeight) { // has scrollbar
    $('html').css({'overflow-y': 'scroll', 'position': 'fixed'});
    $('body').css({'width': '100vw'});
  } else {
    $('html').css({'overflow-y': 'hidden', 'position': 'fixed'});
    $('body').css({'width': '100vw'});
  }

  // popup shadow
  var timeoutId = undefined;
  var $popupContentDiv = $(selector).find('.popup-content');
  $popupContentDiv.on('scroll', function() {
    if (timeoutId) {
      window.clearTimeout(timeoutId);
    }
    var $that = $(this);
    timeoutId = window.setTimeout(function() {
      var y = $that.scrollTop();
      var $bottomShadowDiv = $that.find('.popup-content__more');
      var scrollHeight = $popupContentDiv.get(0).scrollHeight;
      if (scrollHeight <= $that.height()) {
        $bottomShadowDiv.toggleClass('hide', true);
      } else {
        if (y <= 0) {
          $bottomShadowDiv.toggleClass('hide', false);
        } else if (y + $that.height() >= scrollHeight) {
          $bottomShadowDiv.toggleClass('hide', true);
        } else {
          $bottomShadowDiv.toggleClass('hide', false);
        }
      }
    }, 10);
  });
  $(window).on('resize', function() {
    $popupContentDiv.scroll();
  }).resize();
};

/********************************************************
# HIDE POPUP
********************************************************/
gred.hidePopup = function (selector) {
  $(selector).parents('.theme-popup').find('.fpu-bg').removeClass('active');
  setTimeout(function() {
    $(window).scrollTop(window.scrollTop || 0);
    window.scrollTop = undefined;
  }, 0);
  setTimeout(function () {
    $(selector).removeClass('active');
    $(selector + ' .fpu-inner').removeClass('active');
  }, 200);
  $('html').css({'overflow-y': 'auto', 'position': 'inherit'});
  $('body').css({'width': 'inherit'});
}

gred.hideContentPopup = function (selector) {
  $(selector + ' .fpu-inner').removeClass('active');
  $('html').css({'overflow-y': 'auto', 'position': 'inherit'});
  $('body').css({'width': 'inherit'});
}

gred.hideFpu = function () {
  $(document).on('click touchstart', function(e) {
    var dropdown = $('.fpu-inner');
    if (
      !dropdown.is(e.target) && 
      dropdown.has(e.target).length === 0 && 
      dropdown.hasClass('active') &&
      !dropdown.hasClass('fpu-bg-no-dismiss')
    )  {
      $('.fpu-inner').removeClass('active');
      setTimeout(function () {
        gred.dismissModal();
      }, 200);
    }
  });

  $('.l-fpu-close').click(function() {
    $('.fpu-inner').removeClass('active');
    gred.dismissModal();
    return false;
  });
}

gred.dismissModal = function(){
  setTimeout(function() {
    $(window).scrollTop(window.scrollTop || 0);
    window.scrollTop = undefined;    
  }, 0);
  setTimeout(function () {
    $('.fpu-bg').removeClass().addClass('fpu-bg');
    $('.fpu').removeClass('active');
    $.publish("/modal/close", {});
  }, 200);
  $('html').css({'overflow-y': 'auto', 'position': 'inherit'});
  $('body').css({'width': 'inherit'});
}

/********************************************************
# COLLECTION PAGE
********************************************************/
//pagination
gred.pagination = function () {
  ajaxify({
    parentContainer: '#collection-wrap',
    endlessOffset: 50,
    fade: "slow",
    textChange: window.trans["collections.general.loading"]
  });

}


/********************************************************
# PRODUCT PAGE
********************************************************/
gred.btnAddtocartFn = function(event) {
  event.preventDefault();
  if ($(this).attr('disabled') != 'disabled') {
    const $radio0 = $('input[type="radio"][name=option-0]:checked');
    const $radio1 = $('input[type="radio"][name=option-1]:checked');
    const $radio2 = $('input[type="radio"][name=option-2]:checked');
    const selectedVariant = productJSON.variants.find((variant) => {
      return (
        (!$radio0.val() || variant.options[0].replaceAll('"', '-') === $radio0.val()) &&
        (!$radio1.val() || variant.options[1].replaceAll('"', '-') === $radio1.val()) &&
        (!$radio2.val() || variant.options[2].replaceAll('"', '-') === $radio2.val())
      );
    });
    var quantity = $(window.product_detail_form +' input[name=quantity]').val();
    if (!quantity) {
      quantity = 1;
    }

    let hasInstallError = false;
    const $installationOptions = $('input[name="lha-installation"]');
    const $installationDiv = $installationOptions.closest('.product-lha__installation');
    $installationDiv.removeClass('error');
    if (
      $installationOptions.length > 0 && 
      $installationOptions.filter(":checked").length !== 1
    ) {
      setTimeout(function() {
        $installationDiv.addClass('error');
      }, 300);
      hasInstallError = true;
    }

    let hasTakebackError = false;
    const $takebackOptions = $('input[name="lha-takeback"]');
    const $takebackDiv = $takebackOptions.closest('.product-lha__takeback');
    $takebackDiv.removeClass('error');
    if (
      $takebackOptions.length > 0 && 
      $takebackOptions.filter(":checked").length !== 1
    ) {
      setTimeout(function() {
        $takebackDiv.addClass('error');
      }, 300);
      hasTakebackError = true;
    }

    let hasBolttechError = false;
    const $bolttechLis = $('#bolttech-upsell-root').find('li.product-offer');
    const $bolttechMainContent = $('#bolttech-upsell-root').find('.Main-Content');
    if ($bolttechLis.length > 0) {
      $bolttechMainContent.removeClass('error');
      $bolttechLis.find('.Offer-Description').removeClass('error');
      if ($bolttechLis.find('input[type=radio]:checked').length === 0) {
        setTimeout(function() {
          $bolttechMainContent.addClass('error');
          $bolttechLis.find('.Offer-Description').addClass('error');
        }, 300);
        hasBolttechError = true;
      }
      if($(this).hasClass('bolttech-cloned')) {
        gred.showPopup('.fpu-loading');
      }
    }
    if (hasInstallError) {
      $('html, body').stop().animate({
        scrollTop: $(".product-lha__installation").first().offset().top - $('.site-header-container').outerHeight() - $('.breadcrumb').outerHeight() - 15
      }, 600, () => false);
      return false;
    }
    if (hasTakebackError) {
      $('html, body').stop().animate({
        scrollTop: $(".product-lha__takeback").first().offset().top - $('.site-header-container').outerHeight() - $('.breadcrumb').outerHeight() - 15
      }, 600, () => false);
      return false;
    }
    if (hasBolttechError) {
      $('html, body').stop().animate({
        scrollTop: $("#bolttech-upsell-root").first().offset().top - $('.site-header-container').outerHeight() - $('.breadcrumb').outerHeight() - 15
      }, 600, () => false);
      return false;
    }
    gred.doAjaxAddToCart(selectedVariant, parseInt(quantity));
  }
  return false;
}

gred.btnAddtocart = function () {
  $('#btnAddtocart').click(gred.btnAddtocartFn);
}

//PRODUCT ACTION
gred.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      translations = options.translations;

  // Selectors
  var $addToCart = $('#btnAddtocart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice');

  if (variant) {
    //Update variant price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat).replace('.00', '') );
    // var variant_price = quantity * variant.price;
    var variant_price = variant.price;
    var var_price = Shopify.formatMoney(variant.price, moneyFormat).replace('.00', '');
    $productPrice.html( Shopify.formatMoney(variant_price, moneyFormat).replace('.00', '') );
    $('.pruduct-Price').html(var_price);

    //Update compare price
    if (variant.compare_at_price > variant.price) {
      var variant_price = variant.compare_at_price;
      var default_compare_price = Shopify.formatMoney(variant.compare_at_price, moneyFormat).replace('.00', '');
      variant_price = Shopify.formatMoney(variant_price, moneyFormat).replace('.00', '');
      $comparePrice.html(variant_price);

      $('.pruduct-Price-compare').html(default_compare_price);
      $comparePrice.fadeIn(0);
    } else {
      $comparePrice.fadeOut(0);
    }

    $('.vendor-delivery-remark').remove();
    $('.preorder-remark').remove();
    if (variantMF[variant.sku+""].preOrderMsg) {
      $('.product-options').after(variantMF[variant.sku+""].preOrderMsg);
    } else if (variantMF[variant.sku+""].deliveryMsg) {
      $('.product-options').after(variantMF[variant.sku+""].deliveryMsg);
    }

    var isPreOrder = false;
    var preOrderStart = variantMF[variant.sku+""].preOrderStart;
    var preOrderEnd = variantMF[variant.sku+""].preOrderEnd;
		if( preOrderStart !== '' && preOrderEnd !== '') {
      ElecboyTheme.updateCurrentDateTime();
			if (ElecboyTheme.isWithinPeriod( preOrderStart, preOrderEnd )) {
				isPreOrder = true;
			}
		}
    $addToCart.removeClass('hide');
    if ( !variantMF[variant.sku+""].isReleased && !isPreOrder) {
      $addToCart.text(translations.release_soon).attr('disabled', true);
    } else {
      if (variantMF[variant.sku+""].available === "true"){
        $addToCart.html('<img width="16" height="16" src="' + $addToCart.parents('.btn-action').data('icon-src')+ '" alt="" /> ' + translations.add_to_cart).attr('disabled', false);
      } else {
        if( variantMF[variant.sku+""].isFirstReceived ) {
          $addToCart.text(translations.unavailable).attr('disabled', true).addClass('hide');
        } else {
          $addToCart.text(translations.release_soon).attr('disabled', true);
        }
      }
    }
    // Free Gifts
    $('.pdp-gift-records-box').addClass('hide');
    $('.pdp-gift-records-box[data-variant-id="' + variant.id + '"]').removeClass('hide');
    // product description
    $('.tab-content div[data-variant-id]').addClass('hide');
    $('.tab-content div[data-variant-id="' + variant.id + '"]').removeClass('hide');
    // Wishlist
    var $btnWishlist = $('.product-actions .ssw-faveappbtn');
    $btnWishlist.data('variant-id', variant.id);
    // TODO update button text variant oos
  }
}


//UPDATEPRICING
gred.updatePricing = function(){

  var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
  var unitPriceTextMatch = jQuery('.pruduct-Price').text().match(regex);
  var unitComparePriceTextMatch = jQuery('.pruduct-Price-compare').text().match(regex);

  if (!unitPriceTextMatch) {
    regex = /([0-9]+[.|,][0-9]+)/g;
    unitPriceTextMatch = jQuery('.pruduct-Price').text().match(regex);
  }

  if (!unitComparePriceTextMatch) {
    regex = /([0-9]+[.|,][0-9]+)/g;
    unitComparePriceTextMatch = jQuery('.pruduct-Price-compare').text().match(regex);
  }

  if (unitPriceTextMatch) {
    var unitPriceText = unitPriceTextMatch[0];
    var unitPrice = unitPriceText.replace(/[.|,]/g,'');
    var quantity = parseInt(jQuery('#Quantity').val());
    // var totalPrice = unitPrice * quantity;
    var totalPrice = unitPrice * quantity;

    var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format).replace('.00', '');
    regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    if (!totalPriceText.match(regex)) {
      regex = /([0-9]+[.|,][0-9]+)/g;
    }
    if (totalPriceText.match(regex)) {
      totalPriceText = totalPriceText.match(regex)[0];

      var regInput = new RegExp(unitPriceText, "g");
      var totalPriceHtml = jQuery('.pruduct-Price').html().replace(regInput ,totalPriceText);
      $('.product-single .product-single-prices #ProductPrice .money').html(totalPriceHtml);
    }
  }

  if (unitComparePriceTextMatch) {
    var unitPriceText = unitComparePriceTextMatch[0];
    var unitPrice = unitPriceText.replace(/[.|,]/g,'');
    var quantity = parseInt(jQuery('#Quantity').val());
    var totalPrice = unitPrice * quantity;

    var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format).replace('.00', '');
    regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    if (!totalPriceText.match(regex)) {
      regex = /([0-9]+[.|,][0-9]+)/g;
    }

    if ( totalPriceText.match(regex) ) {
    totalPriceText = totalPriceText.match(regex)[0];

      var regInput = new RegExp(unitPriceText, "g");
      var totalPriceHtml = jQuery('.pruduct-Price-compare').html().replace(regInput ,totalPriceText);
      $('.product-single .product-single-prices #ComparePrice .money').html(totalPriceHtml);
    }

  }

}

//Video
jQuery(document).ready(function() {
  $('.product-single-photos .product-video').click(function(e) {
    $(this).toggleClass('active');
    $('.product-single-photos .product-video--content').toggleClass('active');
    $('.product-single-photos .product-pause-close').toggleClass('active');
    var iframe = $('.product-video--content iframe')[0];
    var player = $f(iframe);
    player.api('play');
    e.preventDefault();
  });


  $('.product-single-photos .product-pause-close').click(function(e) {
    $(this).toggleClass('active');
    $('.product-single-photos .product-video--content').toggleClass('active');
    $('.product-single-photos .product-video').toggleClass('active');

    var iframe = $('.product-video--content iframe')[0];
    var player = $f(iframe);
    player.api('pause');
    e.preventDefault();
  });
});


/********************************************************
# AJAX
********************************************************/
//AJAX CART
gred.initAddToCart = function () {
  $('.product-item .btn-addToCart').click(function(event) {
    event.preventDefault();
    if ($(this).attr('disabled') != 'disabled') {
      var productId = $(this).closest('.product-item').attr('data-id');
      productId = productId.match(/\d+/g);

    const $radio0 = $('input[type="radio"][name=option-0]:checked');
    const $radio1 = $('input[type="radio"][name=option-1]:checked');
    const $radio2 = $('input[type="radio"][name=option-2]:checked');
    const selectedVariant = productJSON.variants.find((variant) => {
      return (
        (!$radio0.val() || variant.options[0].replaceAll('"', '-') === $radio0.val()) &&
        (!$radio1.val() || variant.options[1].replaceAll('"', '-') === $radio1.val()) &&
        (!$radio2.val() || variant.options[2].replaceAll('"', '-') === $radio2.val())
      );
    });

      var quantity = $('#AddToCartForm-' + productId + ' input[name=quantity]').val();
      if (!quantity) {
        quantity = 1;
      }
      gred.doAjaxAddToCart(selectedVariant, parseInt(quantity));
    }
    return false;
  });
}

//UPDATE MINICART
gred.updateMiniCart = function(isShowMiniCart) {
  Shopify.getCart(function(cart) {
    const hasDiscountProduct = !!cart.items.find((item) => {
      return item.properties['_type'] === 'discount';
    });
    const isDiscountApplied = !!cart.cart_level_discount_applications.find((discount) => {
      return discount.title === 'New Estates Offer';
    })
    const canCheckout = !hasDiscountProduct || isDiscountApplied;
    $('#new-estate-discount-warning').toggleClass(
      'hide', 
      canCheckout
    );
    $('.js-pre-checkout-process').attr(
      'disabled',
      !canCheckout
    );
    gred.doUpdateMiniCart(cart,isShowMiniCart);
  });
}

gred.updateMiniCart2 = function() {
  Shopify.getCart(function(cart) {
    gred.doUpdateMiniCart2(cart);
  });
}

gred.buildMiniCartItemRow = function(cartItemJson, parentItemJson) {
  var iconSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M160 400C160 408.8 152.8 416 144 416C135.2 416 128 408.8 128 400V192C128 183.2 135.2 176 144 176C152.8 176 160 183.2 160 192V400zM240 400C240 408.8 232.8 416 224 416C215.2 416 208 408.8 208 400V192C208 183.2 215.2 176 224 176C232.8 176 240 183.2 240 192V400zM320 400C320 408.8 312.8 416 304 416C295.2 416 288 408.8 288 400V192C288 183.2 295.2 176 304 176C312.8 176 320 183.2 320 192V400zM317.5 24.94L354.2 80H424C437.3 80 448 90.75 448 104C448 117.3 437.3 128 424 128H416V432C416 476.2 380.2 512 336 512H112C67.82 512 32 476.2 32 432V128H24C10.75 128 0 117.3 0 104C0 90.75 10.75 80 24 80H93.82L130.5 24.94C140.9 9.357 158.4 0 177.1 0H270.9C289.6 0 307.1 9.358 317.5 24.94H317.5zM151.5 80H296.5L277.5 51.56C276 49.34 273.5 48 270.9 48H177.1C174.5 48 171.1 49.34 170.5 51.56L151.5 80zM80 432C80 449.7 94.33 464 112 464H336C353.7 464 368 449.7 368 432V128H80V432z"/></svg>';
  var template = parentItemJson
  ? '<li class="item clearfix" id="cart-item-{id}" data-key="{key}" data-installation-sku="{installationSku}" data-takeback-sku="{takebackSku}">' + 
      '<span title="{title}" class="product-image">' + 
        '{img_tag}' +
      '</span>' + 
      '<div class="product-details text-left">' + 
        '<span class="product-name" href="{url}">{title} {meta}</span>' +
        '{price}<span class="qty">' + window.quantity + '<span>{quantity}</span></span>' + 
        '<a href="javascript:void(0)" title="Remove This Item" class="btn-remove">' + iconSvg + '</a>' +
      '</div>' +
    '</li>'
  : '<li class="item clearfix" id="cart-item-{id}" data-key="{key}" data-installation-sku="{installationSku}" data-takeback-sku="{takebackSku}">' + 
    '<a href="{url}" title="{title}" class="product-image">' + 
      '{img_tag}' +
    '</a>' + 
    '<div class="product-details text-left">' + 
      '<a class="product-name" href="{url}">{title} {meta}</a>' +
      '{price}<span class="qty">' + window.quantity + '<span>{quantity}</span></span>' + 
      '<a href="javascript:void(0)" title="Remove This Item" class="btn-remove">' + iconSvg + '</a>' +
    '</div>' +
  '</li>';
  var item = template;
  var isGift = (cartItemJson.properties && cartItemJson.properties['_type'] === 'gift');
  var isWarranty = (cartItemJson.properties && cartItemJson.properties['_rootProductId']);

  var priceTxt = "";
  
  item = item.replace(/\{id\}/g, cartItemJson.id);
  item = item.replace(/\{key\}/g, cartItemJson.key);
  item = item.replace(/\{installationSku\}/g, cartItemJson.properties['_installationSku']);
  item = item.replace(/\{takebackSku\}/g, cartItemJson.properties['_takebackSku']);
  item = item.replace(/\{url\}/g, cartItemJson.url);
  var title = cartItemJson.product_title;
  if (isWarranty) {
    title = title + ' | ' + parentItemJson.product_title;
  }
  item = item.replace(/\{title\}/g, title);

  if(!isWarranty && $.trim(cartItemJson.variant_title) != ''){
    item = item.replace(/\{meta\}/g, '(<span>'+cartItemJson.variant_title.replace(/#[0-9A-Fa-f]{6}/, ''), + '</span>)' );
  } else{
    item = item.replace(/\{meta\}/g, ' ');
  }
  item = item.replace(/\{quantity\}/g, cartItemJson.quantity);
  item = item.replace(/\{product_id\}/g, cartItemJson.product_id);
  if (cartItemJson.image) {
    var img = Shopify.resizeImage(cartItemJson.image, 'compact');
    item = item.replace(/\{img_tag\}/g, '<img src="' + img + '" alt="' + title +'">');
  } else {
    item = item.replace(/\{img_tag\}/g, $('#tpl-product-default-img').html());
  }
  if( cartItemJson.price == 0 ) {
    priceTxt = window.lang.gift;
  } else {
    priceTxt = Shopify.formatMoney(cartItemJson.price, window.money_format).replace('.00', '');
  }
  item = item.replace(/\{price\}/g, priceTxt);

  if ( isGift ){
    item = item.replace(/btn-remove/g, 'hide');
  }
  return item;
}

/* DO UPDATE MINICART */
gred.doUpdateMiniCart = function(cart, isShowMiniCart) {
  $('.empty').removeClass('empty');
  var cartItemCount = 0;
  for (var i=0; i<cart.items.length; i++) {
    var item = cart.items[i];
    var isInstallation = item.properties && item.properties['_type'] === 'installation';
    var isTakeback = item.properties && item.properties['_type'] === 'takeback';
    if (!isInstallation && !isTakeback) {
      cartItemCount = cartItemCount + item.quantity;
    }
  }
  $('.mini-cart .cart-count').attr('data-count',cartItemCount).data('count',cartItemCount).text(cartItemCount);
  $('.mini-cart .cart-total').html(Shopify.formatMoney(cart.total_price, window.money_format).replace('.00', ''));
  $('.noitice .count').text(cartItemCount);
  $('.miniCart-list').html('');
  if (cartItemCount > 0) {

    $('.miniCart-content .summary').removeClass('hidden');
    $('.miniCart-content .actions').removeClass('hidden');
    $('.miniCart-content .miniCart-list').removeClass('hidden');
    $('.mnl-products .scroll-wrapper').removeClass('hidden');
    $('.miniCart-content .scroll-content').removeClass('hidden');

    var itemFragment = '';
    for (var i = 0; i<cart.items.length; i++) {
      var item = cart.items[i];
      var isInstallation = (item.properties && item.properties['_type'] === 'installation');
      var isTakeback = (item.properties && item.properties['_type'] === 'takeback');
      var isGift = (item.properties && item.properties['_type'] === 'gift');
      var isWarranty = (item.properties && item.properties['_rootProductId']);
      if (!isInstallation && !isTakeback && !isGift && !isWarranty) { // normal item
        var itemHtml = gred.buildMiniCartItemRow(item);
        itemFragment = itemFragment + itemHtml;
        for (var j=0; j<cart.items.length; j++) {
          var ewItem = cart.items[j];
          if (
            ewItem.properties && 
            (ewItem.properties['_rootProductId'] || '').toString() === item.variant_id.toString()
          ) {
            var ewItemHtml = gred.buildMiniCartItemRow(ewItem, item);
            itemFragment = itemFragment + ewItemHtml;
          }
        }
        for (var j=0; j<cart.items.length; j++) {
          var giftItem = cart.items[j];
          if (
            giftItem.properties && 
            giftItem.properties['_type'] === 'gift' &&
            (giftItem.properties['_parent'] || '').toString() === item.variant_id.toString()
          ) {
            var giftItemHtml = gred.buildMiniCartItemRow(giftItem, item);
            itemFragment = itemFragment + giftItemHtml;
          }
        }
      }
    }
    $('.miniCart-list').append($.parseHTML(DOMPurify.sanitize((itemFragment))));
    gred.removeItemsInMiniCart();
    gred.ConvertCurrency();
    gred.checkItemsInMiniCart();
  } else{
    $('.empty').addClass('empty');
    $('.miniCart-content .summary').addClass('hidden');
    $('.miniCart-content .actions').addClass('hidden');
    $('.miniCart-content .miniCart-list').addClass('hidden');
    $('.mnl-products .scroll-wrapper').addClass('hidden');
  }
  if ( isShowMiniCart ) {
    gred.doShowMiniCart(true);
    setTimeout(function(){
      gred.doShowMiniCart(false);
    },5000);
  }
}

gred.doShowMiniCart = function(doOpenMiniCart){
  $('.mini-cart.grt-dropdown a, .mini-cart.grt-dropdown .grt-dropdown--content').toggleClass('active', doOpenMiniCart);
}

/* DO UPDATE MINICART2 */
gred.doUpdateMiniCart2 = function(cart) {
  var cartItemCount = 0;
  for (var i=0; i<cart.items.length; i++) {
    var item = cart.items[i];
    var isInstallation = item.properties && item.properties['_type'] === 'installation';
    var isTakeback = item.properties && item.properties['_type'] === 'takeback';
    if (!isInstallation && !isTakeback) {
      cartItemCount = cartItemCount + item.quantity;
    }
  }
  $('.mini-cart .cart-count').text(cartItemCount);
  $('.mini-cart .cart-total').html(Shopify.formatMoney(cart.total_price, window.money_format).replace('.00', ''));
  $('.noitice .count').text(cartItemCount);
  if (cartItemCount > 0) {
    $('.miniCart-content .summary').removeClass('hidden');
    $('.miniCart-content .actions').removeClass('hidden');
    $('.miniCart-content .miniCart-list').removeClass('hidden');
    $('.mnl-products .scroll-wrapper').removeClass('hidden');

    gred.removeItemsInMiniCart();
    gred.ConvertCurrency();
    gred.checkItemsInMiniCart();
  } else{
    $('.miniCart-content .summary').addClass('hidden');
    $('.miniCart-content .actions').addClass('hidden');
    $('.miniCart-content .miniCart-list').addClass('hidden');
    $('.mnl-products .scroll-wrapper').addClass('hidden');

  }
}


function ajaxCartChange(data) {
  return $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(data),
  });
}

/* REMOVE ITEM CART */
gred.removeItemsInMiniCart = function() {
  $('.btn-remove').click(function(event) {
    event.preventDefault();
    var $itemEl = $(this).parents('.item');
    var itemId = $itemEl.attr('id').match(/\d+/g)[0].toString();
    var itemKey = $itemEl.attr('data-key');
    var installationSku = $itemEl.attr('data-installation-sku');
    var takebackSku = $itemEl.attr('data-takeback-sku');

    $(this).closest('.item').fadeTo("slow", .3);
    ajaxCartChange({ id: itemKey, quantity: 0})
      .then(function(cart) {
        var subsidaries = [];
        for(var i=0; i<cart.items.length; i++) {
          var item = cart.items[i];
          if ( // related gifts
            item.properties && 
            item.properties['_type'] === 'gift' &&
            (item.properties['_parent'] || '').toString() === itemId
          ) {
            subsidaries.push(item.key);
          }
          if ( // related warranties
            item.properties && 
            (item.properties['_rootProductId'] || '').toString() === itemId
          ) {
            subsidaries.push(item.key);
          }
          if ( // related installation service
            item.properties && 
            item.properties['_type'] === 'installation' &&
            item.sku === installationSku &&
            (item.properties['_parent'] || '').toString() === itemId
          ){
            subsidaries.push(item.key);
          }
          if ( // related take-back service
            item.properties && 
            item.properties['_type'] === 'takeback' &&
            item.sku === takebackSku &&
            (item.properties['_parent'] || '').toString() === itemId
          ){
            subsidaries.push(item.key);
          }
        }
        var deferred = $.Deferred().resolve();
        for(var i=0; i < subsidaries.length; i++){
          (function(i){
            deferred = deferred.then(function() {
              return ajaxCartChange({ id: subsidaries[i], quantity: 0 });
            }, function() {
              gred.updateMiniCart();
            });
          })(i);
        }
        return deferred.then(function() {
          gred.updateMiniCart();
        })
      })
      .catch(function(e) {
        $('.error-message').text(e.responseJSON.message.replace(/\[.+\]\s+/, ''));
        gred.showPopup('.fpu-error');
        $itemEl.fadeTo("slow", 1);
      });
  });
};

/* CHECK ITEM MINI CART */
gred.checkItemsInMiniCart = function() {
  if($('.miniCart-list').children().length > 0) {
    $('.miniCart-content').removeClass('empty-cart');
  } else{
    $('.miniCart-content').addClass('empty-cart');
  }
}

gred.resetLHAOptions = function() {
  $('input[name="lha-installation"]').prop('checked', false);
  $('input[name="lha-takeback"]').prop('checked', false);
}

//DO AJAX ADDTOCART
gred.doAjaxAddToCart = function (variant, quantity) {

  function getSelectedVariant(variants, id) {
    var result = null;
    for(var i=0; i<variants.length; i++) {
      var variant = variants[i];
      if (variant.id.toString() === id.toString()) {
        result = variant;
      }
    }
    if (!result) {
      throw new Error('Variant ' + variant.id + ' not found');
    }
    return result;
  }

  function ajaxAddGifts(selectedVariant, quantity, onSuccess, onError) {
    fetch('/products/' + productJSON.handle + '?view=richdata')
      .then(response => response.json())
      .then(function(data){
        var itemsToAdd = [], giftAdjusted = false;
        var v = getSelectedVariant(data.variants, selectedVariant.id);
        for(var i=0; i<v.gifts.length; i++) {
          var g = v.gifts[i];
          // ensure item has available stock and within effective date
          if(
            g.available && 
            g.startDate < window.todayDateTimeStr && 
            g.endDate > window.todayDateTimeStr &&
            g.offlineDate > window.todayDateTimeStr
          ) {
            var giftQty = g.qty * quantity;
            if ((g.inventory_policy == 'deny') && (giftQty > g.inventory)) {
              giftQty = g.inventory;
              giftAdjusted = true;
            }
            var giftVariant = getSelectedVariant(g.product.variants, g.id);
            if (giftQty > 0) {
              itemsToAdd.push({
                id: g.id,
                quantity: giftQty,
                properties: {
                  _parent: selectedVariant.id.toString(),
                  _quantity: g.qty,
                  _type: 'gift',
                  _productId: g.product.id,
                  _variantId: g.id,
                  _url: '/products/' + g.handle + '?variant=' + g.id,
                  _title: g.product.title + ' ' + giftVariant.title.replace(/#[0-9A-Fa-f]{6}/, ''),
                }
              });
            }
          }
        }
        if ( itemsToAdd.length ){
          $.ajax({
            url:'/cart/add.js',
            type:'post',
            contentType: 'application/json;charset=utf-8',
            dataType:'json',
            data: JSON.stringify({
              items: itemsToAdd
            }),
            success: function() {
              onSuccess(giftAdjusted);
            },
            error: onError,
          });
        } else {
          onSuccess(giftAdjusted);
        }
      });
  }

  function ajaxAddProduct(selectedVariant, quantity, onSuccess, onError) {
    $.ajax({
      type: "get",
      url: "/cart.js",
      contentType : 'application/json;charset=utf-8',
      dataType: 'json',
      success: function(cart) {
        const existingQuantity = cart.items
          .filter((item) => item.variant_id === selectedVariant.id)
          .reduce((acc, item) => acc + item.quantity, 0);
        const quantityToAdd = Math.min(quantity, window.config.max_product_quantity - existingQuantity);
        if (quantityToAdd < quantity) {
          gred.hidePopup('.fpu-loading');
          $('.error-message').text(window.lang['max-quantity-reached']);
          gred.showPopup('.fpu-error');
        }
        if (quantityToAdd > 0) {
          let hardBundleItems = [];
          if (selectedVariant.hardBundle) {
            $('.input-product-hard-bundle-qty').each(function() {
              const qty = parseInt($(this).val());
              if (qty > 0) {
                const sku = $(this).closest('div.product-container').find('select').find('option:selected').data('sku').toString();
                const bundledSku = selectedVariant.hardBundle.bundledSkus.find((item) => item.sku === sku);
                const variant = bundledSku.product.variants.find((variant) => variant.sku === sku);
                hardBundleItems.push({
                  id: variant.id,
                  quantity: qty,
                  properties: {
                    _productId: bundledSku.product.id,
                    _variantId: variant.id,
                    _url: '/products/' + bundledSku.product.handle + '?variant=' + variant.id,
                    _title: bundledSku.product.title + ' ' + variant.title.replace(/#[0-9A-Fa-f]{6}/, ''),
                  }
                });
              }
            });
          }
          const timestamp = Date.now();
          $.ajax({
            type: "post",
            url: "/cart/add.js",
            data: JSON.stringify({
              items: [{
                id: selectedVariant.id,
                quantity: quantityToAdd,
                properties: {
                  _productId: productJSON.id,
                  _variantId: selectedVariant.id,
                  _type: selectedVariant.isDiscount ? 'discount' : undefined,
                  _url: '/products/' + productJSON.handle + '?variant=' + selectedVariant.id,
                  _title: productJSON.title + ' ' + selectedVariant.title.replace(/#[0-9A-Fa-f]{6}/, ''),
                  ...installationSku ? {
                    _installationSku: installationSku,
                    _need_site_survey: selectedVariant.needSiteSurvey,
                  } : {},
                  ...takebackSku ? { _takebackSku: takebackSku } : {},
                  ...(installationSku || takebackSku) ? { _timestamp: timestamp } : {},
                },
              },
                ...(hardBundleItems.length > 0 ? hardBundleItems : []),
              ]
            }),
            contentType: 'application/json;charset=utf-8',
            dataType: 'json',
            success: function() {
              if (selectedInstallationOption || selectedTakebackOption) {
                ajaxAddInstallationTakeback(quantityToAdd, timestamp, onSuccess, onError);
              } else {
                onSuccess();
              }
            },
            error: function(xhr) {
              if (xhr.status === 422 && (selectedInstallationOption || selectedTakebackOption)) {
                $.ajax({
                  type: "get",
                  url: "/cart.js",
                  contentType : 'application/json;charset=utf-8',
                  dataType: 'json',
                  success: function(cart) {
                    const item = cart.items.find((item) => {
                      return (
                        item.id === selectedVariant.id &&
                        item.properties['_timestamp'] === timestamp
                      );
                    });
                    if (item) {
                      ajaxAddInstallationTakeback(item.quantity, timestamp, function() {
                        onSuccess();
                        gred.hidePopup('.fpu-loading');
                        $('.error-message').text($.parseJSON(xhr.responseText).description);
                        gred.showPopup('.fpu-error');
                      }, onError);
                    } else {
                      onError(xhr);
                    }
                  },
                  error: onError
                });
              } else {
                onError(xhr);
              }
            }
          });
        }
      },
      error: function(xhr) {
        onError();
      }
    });
  }

  function ajaxAddInstallationTakeback(quantity, timestamp, onSuccess, onError) {
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: JSON.stringify({
        items: [
          ...selectedInstallationOption ? [{
            id: selectedInstallationOption.variantId,
            quantity: quantity,
            properties: {
              _parent: selectedVariant.id.toString(),
              _timestamp: timestamp,
              _type: 'installation',
              _title: lang === 'en'
                ? selectedInstallationOption.titleEN
                : selectedInstallationOption.titleZT,
            }
          }]: [],
          ...selectedTakebackOption ? [{
            id: selectedTakebackOption.variantId,
            quantity: quantity,
            properties: {
              _parent: selectedVariant.id.toString(),
              _timestamp: timestamp,
              _type: 'takeback',
              _title: lang === 'en'
                ? selectedTakebackOption.titleEN
                : selectedTakebackOption.titleZT,
            }
          }]: [],
        ]
      }),
      contentType: 'application/json;charset=utf-8',
      dataType: 'json',
      success: onSuccess,
      error: onError,
    });
  }

  function ajaxUpdateWarrantyProperties(onSuccess, onError) {
    $.ajax({
      type: "get",
      url: "/cart.js",
      contentType : 'application/json;charset=utf-8',
      dataType: 'json',
      success: function(cart) {
        var ewLineItems= [];
        for (var i=0; i<cart.items.length; i++) {
            var lineItem = cart.items[i];
            if (
              lineItem.properties && 
              lineItem.properties['_rootProductId'] === selectedVariant.id &&
              !lineItem.properties['_productId']
            ) {
                var properties = lineItem.properties;
                properties['_productId'] = lineItem.product_id;
                properties['_variantId'] = lineItem.variant_id;
                properties['_url'] = lineItem.url;
                properties['_title'] = lineItem.product_title + ' ' + lineItem.variant_title.replace(/#[0-9A-Fa-f]{6}/, ''),
                ewLineItems.push({
                  id: lineItem.key,
                  properties: properties
                });
            }
        }
        if (ewLineItems.length > 0) {
          // Fire requests in sequetially as /cart/change.js does not support parallel
          var deferred = $.Deferred().resolve();
          for(var i=0; i < ewLineItems.length; i++){
            (function(i){
              deferred = deferred.then(function() {
                return ajaxCartChange(ewLineItems[i]);
              }, onError);
            })(i);
          }
          deferred.then(onSuccess);
        } else {
          onSuccess();
        }
      }, 
      error: onError
    })
  }

  gred.showPopup('.fpu-loading');
  var lang = $('html').attr('lang') === 'en' ? 'en' : 'tc';
  var selectedVariant = getSelectedVariant(productJSON.variants, variant.id);
  var installationSku = selectedVariant.hasInstallation
    ? $('input[name="lha-installation"]:checked').val()
    : undefined;
  var takebackSku = selectedVariant.hasTakeback
    ? $('input[name="lha-takeback"]:checked').val()
    : undefined;
  var selectedInstallationOption = installationSku
    ? selectedVariant.installationOptions.find((option) => option.sku === installationSku)
    : undefined;
  var selectedTakebackOption = takebackSku
    ? selectedVariant.takebackOptions.find((option) => option.sku === takebackSku)
    : undefined;
  ajaxUpdateWarrantyProperties(
    function() {
      $('.product-hard-bundle').removeClass('error');
      ajaxAddProduct(
        selectedVariant,
        quantity,
        function() {
          ajaxAddGifts(
            selectedVariant,
            quantity,
            function(giftAdjusted){
              gred.hidePopup('.fpu-loading');
              if( giftAdjusted ){
                $('.error-message').text(window.lang['gift-oos-add-to-cart-adjusted']);
                gred.showPopup('.fpu-error');
              }
              gred.resetLHAOptions();
              gred.finalizeCart();
            },
            function(err){
              gred.hidePopup('.fpu-loading');
              $('.error-message').text(err.responseJSON.description);
              gred.showPopup('.fpu-error');
              gred.finalizeCart();
            }
          );
        },
        function(xhr, text) {
          gred.hidePopup('.fpu-loading');
          var json = $.parseJSON(xhr.responseText);
          if (json.description.startsWith('[HardBundle]')) {
            $('.product-hard-bundle').addClass('error');
            $('.product-hard-bundle .title').addClass('error');
            $('html, body').stop().animate({
              scrollTop: $('.product-hard-bundle').first().offset().top - $('.site-header-container').outerHeight() - $('.breadcrumb').outerHeight() - 15
            }, 600, () => false);
          } else {
            $('.error-message').text(json.description);
            gred.showPopup('.fpu-error');
          }
        }
      );
    },
    function(xhr) {
      gred.hidePopup('.fpu-loading');
      $('.error-message').text($.parseJSON(xhr.responseText).description);
      gred.showPopup('.fpu-error');
    }
  );
}

gred.finalizeCart = function(){
  if ( window.innerWidth < 768 ) {
    gred.bonceCartQty();
  } else {
    $('body,html').animate({scrollTop:0}, 500, gred.bonceCartQty);
  }

  gred.updateMiniCart(true);
}

gred.bonceCartQty = function() {
  $('.cart-count').removeClass('animate__bounce');
  setTimeout(function(){
    $('.cart-count').addClass('animate__bounce');
  },100);
}

/********************************************************
# CONVERTTOSLUG
********************************************************/
gred.convertToSlug = function (text) {
  return text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
}

/********************************************************
# CURRENCY
********************************************************/

/* reConvertCurrency */
gred.reConvertCurrency = function() {
  return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
};


gred.ConvertCurrency = function() {
  if (gred.reConvertCurrency() && window.show_multiple_currencies ) {
    Currency.convertAll(window.shop_currency, jQuery('.currency-picker').val(), 'span.money', window.config['currency_format'] );
  }
}

gred.upsellPricesOverride = function(isPageLoad = true) {
  const upsellPrices = window.upsellPrices.filter((upsellPrice) => {
    const startAt = upsellPrice['start-at'];
    const endAt = upsellPrice['end-at'];
    return window.todayDateTimeStr >= startAt && window.todayDateTimeStr <= endAt;
  }).reduce((data, upsellPrices) => {
    return {
      ...data,
      ...(upsellPrices.data || {}),
    };
  }, {});

  let maxLength = 0;
  setInterval(function() {
    $titles = $('a[data-essential-upsell-element="title"]');
    if ($titles.length > maxLength) {
      maxLength = $titles.length;
      $titles.each(function(_, $el) {
        const $content = $(this).closest('div[data-essential-upsell-element="content"]');
        const $variantSelect = $content.find('div[data-essential-upsell-element="variant-select"] select');
        const $regularPrice = $content.find('div[data-essential-upsell-element="regular-price"]');
        const $discountedPrice = $content.find('div[data-essential-upsell-element="discounted-price"]');
        const slug = $el.href.split('/products/')[1];
        const newPrice = $variantSelect.length > 0 && upsellPrices.hasOwnProperty(slug)
          ? upsellPrices[slug][parseInt($variantSelect.first().val())]
          : upsellPrices[slug];
        if (newPrice) {
          const newPriceStr = '$' + newPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          if ($discountedPrice.length > 0) {
            $discountedPrice.text(newPriceStr);
          } else if ($regularPrice.length > 0){
            $regularPrice.text(newPriceStr);
            $regularPrice.css({ color: 'red' });
          }
        } else {
          if ($discountedPrice.length > 0) {
            const oldPrice = $discountedPrice.attr('data-discounted-price-value');
            const oldPriceStr = '$' + oldPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            $discountedPrice.text(oldPriceStr);
          }
          if ($regularPrice.length > 0) {
            const oldPrice = $regularPrice.attr('data-regular-price-value');
            const oldPriceStr = '$' + oldPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            $regularPrice.text(oldPriceStr);
            $regularPrice.css({ color: '' });
          }
        }
        if ($discountedPrice.length > 0) {
          $discountedPrice.text($discountedPrice.text().replace('.00', ''));
        }
        if ($regularPrice.length > 0) {
          $regularPrice.text($regularPrice.text().replace('.00', ''));
        }
      });
      if (isPageLoad) {
        $('button[data-essential-upsell-element="button-left"]').click(function() {
          gred.upsellPricesOverride(false);
        });
        $('button[data-essential-upsell-element="button-right"]').click(function() {
          gred.upsellPricesOverride(false);
        });
        $('[data-essential-upsell-element="variant-select"] select').change(function() {
          gred.upsellPricesOverride(false);
        });
      }
    }
  }, 1000);
}

gred.overrideGrowaveWishlistStyles = function() {
  function overrideSidebarPrices(root) {
    setInterval(function() {
      [
        ...root.querySelectorAll('.gw-wl-item-price'),
        ...root.querySelectorAll('.gw-wl-item-compare-price')
      ].forEach((el) => {
        if (el.classList.contains('elecboy-overrided')) {
          return;
        }
        el.classList.add('elecboy-overrided');
        el.innerText = el.innerText.replaceAll('HK$', '$').replaceAll('.00', '');
      });
    }, 100);
  }
	function attachCustomSidebarStyle() {
    var isInitialized = false;
    setInterval(function() {
      if (isInitialized) {
        return;
      }
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(`
.gw-wl-theme--wrapped {
  --gw-theme-main-text-primary: #000000 !important;
}
.gw-wl__header-title svg,
.gw-wl-item-badge,
.gw-wl-item__cart-btn,
.gw-empty-state__description,
.gw-empty-state__footer,
.gw-actions-list-actions > li:nth-child(3) {
  display: none !important;
}
.gw-empty-state {
  padding-bottom: 0 !important;
}
.gw-wl-item-price {
  color: var(--color-price) !important;
}
.gw-wl-item-content__price-block {
  justify-content: flex-end !important;
  flex-direction: row-reverse !important;
}
.gw-wl .gw-btn.gw-button.--outlined {
  color: #ffffff !important;
  background-color: #ff0055 !important;
  border: 0 !important;
  focus: 0 !important;
  border-radius: 3px !important;
  box-shadow: none !important;
}
.gw-wl .gw-btn.gw-button.--outlined:hover {
  background-color: #c60345 !important;
}
.gw-wl .gw-btn.gw-button.--outlined svg fill{
  fill: #ffffff !important;
}
`);
      var $el = $('.gw-wl-drawer-widget-placeholder');
      if ($el.length > 0) {
        var root = $el.get(0).shadowRoot;
        var drawer = root.querySelector('.gw-wl-widget-container');
        if (drawer) {
          const drawerRoot = drawer.shadowRoot;
          if (drawerRoot) {
            drawerRoot.adoptedStyleSheets.push(sheet);
            overrideSidebarPrices(drawerRoot);
            isInitialized = true;
          }
        }
      }
    }, 100);
  }
  function overrideSidebarStyles() {
    var isInitialized = false;
    setInterval(function () {
      if (isInitialized) {
        return;
      }
      var $root = $('.gw-widget-placeholder-RC>div');
      if ($root.length > 0) {
        var root = $root.get(0).shadowRoot;
        if (root) {
          const sheet = new CSSStyleSheet();
          if (window.customer) {
            sheet.replaceSync(`
.gw-drawer-open-btn__text {
  font-size: calc(var(--txt-body) * 1.2) !important;
}
            `);
          } else {
            sheet.replaceSync(`
.gw-wl-drawer-button-wrapper {
  display: none !important;
}
            `);
          }
          root.adoptedStyleSheets.push(sheet);
          var openDrawerBtn = root.querySelector('button.gw-drawer-open-btn');
          openDrawerBtn && openDrawerBtn.addEventListener('click', attachCustomSidebarStyle, false);
          isInitialized = true;
        }
      }
    }, 300);
  }

  function overridePagePrices(root) {
    setInterval(function() {
      [
        ...root.querySelectorAll('.gw-wl-page-item-price'),
        ...root.querySelectorAll('.gw-wl-page-item-compare-price')
      ].forEach((el) => {
        if (el.classList.contains('elecboy-overrided')) {
          return;
        }
        el.classList.add('elecboy-overrided');
        el.innerText = el.innerText.replaceAll('HK$', '$').replaceAll('.00', '');
      });
    }, 100);
  }
  function overridePageStyles() {
    var isInitialized = false;
    setInterval(function () {
      if (isInitialized) {
        return;
      }
      var $root = $('.gw-wl-page-placeholder');
      if ($root.length > 0) {
        var root = $root.get(0).shadowRoot;
        if (root) {
          const sheet = new CSSStyleSheet();
          sheet.replaceSync(`
.gw-wl-page__wrapper {
  --gw-theme-main-text-primary: #000000 !important;
}
.gw-badge,
.gw-empty-state__description,
.gw-actions-list-actions > li:nth-child(3),
.gw-wl-page-item__footer,
.gw-empty-state__content,
.gw-empty-state__footer {
  display: none !important;
}
div.gw-wl-page button, 
div.gw-wl-page .gw-btn.gw-button, 
.gw-wl-add-to-cart-btn {
  border-radius: 3px !important;
}
.gw-wl-page-item-price {
  color: var(--color-price) !important;
}
.gw-wl-page-item-content__price-block {
  justify-content: flex-end !important;
  flex-direction: row-reverse !important;
}
.gw-wl-page__add-list-btn {
  background: var(--color-primary-pink) !important;
  color: #fff !important;
  border-radius: 3px !important;
}
.gw-wl-page__add-list-btn:hover {
  opacity: 1 !important;
  background: #c60345 !important;
  box-shadow: none !important;
}
          `);
          root.adoptedStyleSheets.push(sheet);
          overridePagePrices(root);
          isInitialized = true;
        }
      }
    }, 300);
  }
  (function() {
    overridePageStyles();
    overrideSidebarStyles();
  })();
}

$(gred.init);
